import { PDLTypography } from "../../dna";

const Copyright = () => (
  <PDLTypography size="sm">
    &copy; Copyright {new Date().getFullYear()} LEX EDITORA.
  </PDLTypography>
);

export default Copyright;
